import { render, staticRenderFns } from "./userLogList.vue?vue&type=template&id=12fcff24&scoped=true"
import script from "./userLogList.vue?vue&type=script&lang=js"
export * from "./userLogList.vue?vue&type=script&lang=js"
import style0 from "./userLogList.vue?vue&type=style&index=0&id=12fcff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fcff24",
  null
  
)

export default component.exports